import { InjectionToken } from '@angular/core';

export const ACTIVE_CAMPAIGN_ACCOUNT_ID = new InjectionToken<string | undefined>('active-campaign-account-id');
